//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DurationField from '../Field/DurationField.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyDuration',
  components: {
    DurationField
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    let data = {
      placeholder: null
    }

    const config = this.tabProp || this.config || {}
    if (config.componentProps) {
      data = Object.assign(data, config.componentProps)
    }

    return data
  },
  computed: {
    format: function () {
      return 'DD дн. HH:mm:ss.SSS'
    },
    iconTooltip: function () {
      if (this.tabProp.descr && this.tabProp.descr.length) {
        return this.tabProp.descr
      }
      return null
    }
  }
}
